import { keys } from 'lodash';
import * as types from './types';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import {
  api,
  chunkedMultiIdApiCall,
  apiActionDispatcher,
  multiIdRequestCacheCheck,
  signalRWrappedApiCall
} from './api';
import {
  groupJobRelationshipsByParentJobId,
  jobScenariosReducer
} from '../reducers';
import { payloadsByIdHandler } from './signalRHub/hubPayloadsHandler';

const fetchJobRelationshipsDispatcher = apiActionDispatcher(
  { actionTypes: types.jobRelationshipsActionTypes }
);

export const fetchJobRelationshipsByJobIds = (parentJobIds) => signalRWrappedApiCall(
  chunkedMultiIdApiCall(
    parentJobIds,
    4000,
    () => fetchJobRelationshipsDispatcher,
    api.jobRelationships.fetchJobRelationshipsByJobIds,
    (state, ids) => multiIdRequestCacheCheck(state.jobRelationships.request, ids)
  ),
  fetchJobRelationshipsDispatcher,
  signalRHubManager,
  subscriptionTypes.jobsRelationships,
  state => keys(groupJobRelationshipsByParentJobId(state)),
  (args, payloads) => payloadsByIdHandler(args, payloads, 'parent_job_id')
);


const fetchJobScenariosDispatcher = apiActionDispatcher(
  { actionTypes: types.jobScenariosActionTypes }
);

export const fetchJobScenariosByScenarioIds = (scenarioIds) => signalRWrappedApiCall(
  chunkedMultiIdApiCall(
    scenarioIds,
    4000,
    () => fetchJobScenariosDispatcher,
    api.jobRelationships.fetchJobScenariosByScenarioIds,
    (state, ids) => multiIdRequestCacheCheck(state.jobScenarios.request, ids)
  ),
  fetchJobScenariosDispatcher,
  signalRHubManager,
  subscriptionTypes.jobScenarios,
  state => keys(jobScenariosReducer.groupJobScenariosByScenarioId(state)),
  (args, payloads) => payloadsByIdHandler(args, payloads, 'scenario_id')
);


// WEBPACK FOOTER //
// src/actions/jobRelationships.js